/**
 * Common utils
 */

define(function(require, exports, module) {
    'use strict';

    const _ = require('underscore');

    var _deepClone = function(source) {
        if (!(source instanceof Object)) {
            return source;
        }

        var target;

        switch (source.constructor) {
            case Array:
                target = [];
                break;
            case Date:
                target = new Date(source);
                break;
            case RegExp:
                target = new RegExp(source);
                break;
            case Function:
                // Pass real reference to source function
                // because there is absolutely no way (and no real need) to copy a function in javascript
                target = source;
                break;
            default:
                target = {};
        }

        // NB this also copies array properties
        // todo 1. built-in types have special properties in their instances that should not be written!
        // like array.length. We must somehow filter them out!
        for (var prop in source) {
            if (Object.hasOwnProperty.call(source, prop)) {
                target[prop] = _deepClone(source[prop]);
            }
        }

        return target;
    };

    var _deepExtend = function(target, source, isArrayMerge) { // eslint-disable-line no-unused-vars
        var sourceType, targetType;

        for (var prop in source) {
            targetType = Object.prototype.toString.call(target[prop]);
            sourceType = Object.prototype.toString.call(source[prop]);

            // todo 1. built-in types have special properties in their instances that should not be written!
            // like array.length

            // todo 2. By default we overwrite array with new deepClone of array
            // if (isArrayMerge) we should make some array merging by pushing new items instead of overwriting

            // check if property is of extendable type
            if (targetType === sourceType && targetType === '[object Object]') {
                _deepExtend(target[prop], source[prop]);
            } else {
                target[prop] = _deepClone(source[prop]);
            }
        }
    };

    var utils = {

        checkBirthdate: function($daySelector, $monthSelector, $yearSelector) {
            var selectedMonth = $monthSelector.val() || new Date().getMonth();
            var selectedYear = $yearSelector.val() || new Date().getFullYear();
            var $options = $daySelector.find('option');
            var optionsLength = $options.length - 1;
            var days = new Date(selectedYear, selectedMonth, 0).getDate();
            var day;

            if (optionsLength < days) {
                for (day = optionsLength + 1; day <= days; day++) {
                    $daySelector.append('<option value="' + day + '">' + day + '</option>');
                }
            } else if (optionsLength > days) {
                if ($daySelector[0].selectedIndex > days) {
                    $daySelector[0].selectedIndex = 1;

                    // NB: possible bug in FF when triggering this just after removing 'disabled' attribute from el
                    $daySelector.trigger('change');
                }
                for (day = optionsLength; day > days; day--) {
                    $options.eq(day).remove();
                }
            }
        },

        guid: function() {
            function s4() {
                return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
            }

            return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
        },

        /**
         * Deep extend. Does NOT detect circular references
         * @param {Object|Array} target
         * @param {...Object|Array} source - one or more sources
         * @returns {Object|Array}
         */
        deepExtend: function(target, source) {
            var isArrayMerge = arguments[arguments.length - 1] === true;

            if (arguments.length === 2) {
                source && _deepExtend(target, source, isArrayMerge);
            } else if (arguments.length > 2) {
                for (var i = 1; i < arguments.length; i++) {
                    arguments[i] && _deepExtend(target, arguments[i], isArrayMerge);
                }
            }
            return target;
        },

        /**
         * Deep clone. Does NOT detect circular references
         * @param {*} source
         * @returns {*}
         */
        deepClone: function(source) {
            return _deepClone(source);
        },

        /**
         * Creates a shallow copy of the provided plain object.
         * Any nested objects or arrays will be copied by reference, not duplicated.
         * Any provided non-object parameters will be returned as is.
         * @param object
         * @return {*}
         */
        cloneObject: function(object) {
            if (object != null && object.constructor === Object) {
                var propNames = Object.getOwnPropertyNames(object);
                var descriptors = propNames.map(Object.getOwnPropertyDescriptor.bind(null, object));

                return Object.defineProperties({}, _.object(propNames, descriptors));
            }

            return object;
        },

        evalJavaScript: function(data) {
            var correctedData = String(data);
            var head = document.getElementsByTagName('head')[0];
            var script = document.createElement('script');
            script.type = 'text/javascript';

            correctedData = correctedData.replace(/<script(.*?)>/g, '');
            correctedData = correctedData.replace(/<\/script>/g, '');

            try {
                // doesn't work on ie
                script.appendChild(document.createTextNode(correctedData));
            } catch (e) {
                // IE has funky script nodes
                script.text = correctedData;
            }

            head.insertBefore(script, head.firstChild);
            head.removeChild(script);
        },

        string: {
            format: function(value) {
                var params, regexp;
                if (arguments[1] !== undefined) {
                    params = Array.prototype.slice.call(arguments, 1);
                    for (var i = 0; i < params.length; i++) {
                        regexp = new RegExp('\\{' + i + '\\}', 'g');
                        value = value.replace(regexp, params[i]);
                    }
                }
                return value;
            }
        },

        /**
         * Any predicate may be reverted by adding '-' sign before it OR changing arguments order
         * @example descending sort:
         * list.sort(function(a, b) {
         *     return -utils.predicate.stringPredicate(a, b);
         * });
         * list.sort(function(a, b) {
         *     return utils.predicate.stringPredicate(b, a);
         * });
         */
        predicate: {
            boolPredicate: function(first, second) {
                if (first === second) {
                    return 0;
                }
                if (first) {
                    return -1;
                }
                if (second) {
                    return 1;
                }
                return 0;
            },

            numberPredicate: function(first, second) {
                var isFirstNumber = _.isNumber(first) && !isNaN(first);
                var isSecondNumber = _.isNumber(second) && !isNaN(second);
                if (first === second || !isFirstNumber && !isSecondNumber) {
                    return 0;
                }
                if (!isSecondNumber) {
                    return -1;
                }
                if (!isFirstNumber) {
                    return 1;
                }
                return second - first;
            },

            stringPredicate: function(first, second) {
                if (first === second) {
                    return 0;
                }
                if (first > second) {
                    return 1;
                }
                if (first < second) {
                    return -1;
                }
                return 0;
            }
        },

        /**
         * Decimal number validation
         * @param  {*}  num
         * @return {boolean}
         */
        isNumeric: function(num) {
            return !isNaN(parseFloat(num)) && isFinite(num);
        },

        /**
         * Safely get nested property
         * @param {Object} object
         * @param {string|Array} path
         * @return {*}
         */
        fromPath: function(object, path) {
            if (path === '') {
                return object;
            }
            if (_.isString(path)) {
                path = path.split('.');
            }
            return path.reduce(function(value, key) {
                return value == null ? value : value[key];
            }, object);
        },

        deepFind: function(items, childrenKey, sourceKey, source) {
            var item, result;

            if (!_.isArray(items)) {
                return;
            }

            for (var i = 0, len = items.length; i < len; i++) {
                item = items[i];

                if (item[sourceKey] === source) {
                    return item;
                } else if (item[childrenKey]) {
                    result = utils.deepFind(item[childrenKey], childrenKey, sourceKey, source);
                }

                if (result) {
                    return result;
                }
            }
        },

        /**
         * Checks if all specified keys are present in object
         * @param {Object} object
         * @param {Array} keys
         * @return {boolean}
         */
        validate: function(object, keys) {
            return !_.some(keys, function(key) {
                return !_.contains(_.keys(object), key);
            });
        },

        capitalize: function(word) {
            return word.charAt(0).toUpperCase() + word.slice(1);
        },

        /**
         * Private object, generate regexp for 'replaceHtmlEntities' method
         */
        _escapeHtmlModule: (function() {
            var map = {
                    '&': '&amp;',
                    '<': '&lt;',
                    '>': '&gt;',
                    '"': '&quot;',
                    '/': '&#x2F;'
                };
            var symbols = Object.keys(map).join('');
            var regexp = new RegExp('[' + symbols + ']', 'g');
            return {
                regexp: regexp,
                replaceTag: function(tag) {
                    return map[tag] || tag;
                }
            };
        })(),

        /**
         * Replace unsafe symbols, for prevent XSS attack
         * @param  {string}   str [unsafe string]
         * @return {[string]}     [return safe string]
         */
        replaceHtmlEntities: function(str) {
            var mod = this._escapeHtmlModule;

            return typeof str === 'string' ? str.replace(mod.regexp, mod.replaceTag) : str;
        },

        /**
         * Logical XOR (Exclusive OR)
         * @param {*} a
         * @param {*} b
         * @return {boolean}
         */
        xor: function(a, b) {
            return Boolean(a) !== Boolean(b);
        },

        /**
         * Logical XAND (Exclusive AND)
         * @param {*} a
         * @param {*} b
         * @return {boolean}
         */
        xand: function(a, b) {
            return Boolean(a) === Boolean(b);
        }
    };

    module.exports = utils;
});
